module.exports = __webpack_public_path__ + "img/logo_hk.c99a13e7.webp";